<template>
  <div class="addCard" :style="{ height: winh + 'px' }">
    <div class="top">
      <span class="icon" @click="goback"></span>
      <span class="title">银行卡信息</span>
    </div>

    <div class="textBox">
      <ul>
        <li>
          <span>持卡人</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入持卡人姓名"
            v-model="bank_info.card_holder"
          />
        </li>
        <li>
          <span>银行卡号</span>
          <input
            type="tel"
            maxlength="19"
            minlength="16"
            name=""
            id=""
            placeholder="请输入卡号信息"
            v-model="bank_info.card_account"
            class="active"
          />
        </li>
        <li>
          <span>开户银行</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入开户银行"
            class="active"
            v-model="bank_info.bank_name"
          />
        </li>
        <li>
          <span>开户支行</span>
          <input
            type="text"
            name=""
            id=""
            placeholder="请输入支行信息"
            class="active"
            v-model="bank_info.bank_branch"
          />
        </li>
      </ul>
    </div>

    <div class="finBt">
      <button
        @click="goMycard"
        :class="
          bank_info.card_account.replace(/\s*/g, '').length == 19 &&
          bank_info.card_holder.replace(/\s*/g, '').length != 0 &&
          bank_info.bank_name.replace(/\s*/g, '').length != 0 &&
          bank_info.bank_branch.replace(/\s*/g, '').length != 0
            ? 'active'
            : ''
        "
        :disabled="
          bank_info.card_account.replace(/\s*/g, '').length != 19 ||
          bank_info.card_holder.replace(/\s*/g, '').length == 0 ||
          bank_info.bank_name.replace(/\s*/g, '').length == 0 ||
          bank_info.bank_branch.replace(/\s*/g, '').length == 0
        "
      >完成
      </button>
    </div>
    <span class="mytxt">*您所提供的银行卡信息仅用于收入发放。</span>
  </div>
</template>

<script>
import Vue from 'vue'
import agent from '@/agents/bank'
export default Vue.extend({
  name: "addCard",
  data() {
    return {
      winh: 0,
      bank_info: {
        bank_name: "",
        bank_branch: "",
        card_account: "",
        card_holder: "",
      },
    };
  },
  created() {
    //背景图高度自适应
    let _this = this;
    this.winh = window.innerHeight;
    window.onresize = function () {
      _this.winh = window.innerHeight;
    };
  },
  methods: {
    goback() {
        this.$router.go(-1);
    },
    async goMycard() {
        this.change_bank_card()
    },
    async change_bank_card() {
        const { ok, message, data } = await agent.update_bank_info(this.bank_info)
        if (!ok) {
            return
        } else {
            this.$router.replace({name:'myCard'})
        }
    },
  },
})
</script>


<style lang="scss" scoped>
.addCard {
  width: 100%;
  background-color: #f7f8f9;
  position: relative;
  overflow: hidden;
  .top {
    width: 100%;
    height: 56px;
    position: relative;
    margin-top: 24px;
    .icon {
      display: block;
      width: 25px;
      height: 25px;
      background-image: url("../assets/close.png");
      background-size: 25px 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      margin-top: -12px;
    }
    .title {
      display: block;
      font-weight: 500;
      font-size: 16px;
      color: black;
      text-align: center;
      line-height: 56px;
    }
  }
  .textBox {
    width: 100%;
    background-color: white;
    margin-top: 16px;
    ul {
      width: 100%;
      li {
        width: 100%;
        padding: 0px 0px 0px 32px;
        border-bottom: 1px solid rgb(230, 230, 230);
        box-sizing: border-box;
        height: 46px;
        display: flex;
        align-items: center;
        ::-webkit-input-placeholder {
          color: #bdbec1;
          font-size: 14px;
        }
        span {
          display: block;
          font-size: 14px;
          color: #50525b;
        }
        input {
          display: block;
          flex-grow: 1;
          flex-shrink: 0;
          height: 46px;
          border: none;
          font-size: 14px;
          padding-left: 36px;
          box-sizing: border-box;
          background-color: transparent;
        }
        .active {
          padding-left: 22px;
        }
      }
    }
  }
  .finBt {
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;
    position: absolute;
    top: 85%;
    button {
      width: 100%;
      height: 52px;
      border: none;
      line-height: 52px;
      text-align: center;
      border-radius: 67px;
      font-size: 16px;
      background-color: #dcdde0;
      color: #ffffff;
      &.active {
        background-color: #70b2ff;
        color: white;
      }
    }
  }
  .mytxt {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #bdbec1;
    text-align: center;
    position: absolute;
    top: 95%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>